import { createFileRoute } from "@tanstack/react-router";
import SitemapPage from "@/pages/Sitemap";
import { sitemapHead } from "@/lib/route-seo";

export const Route = createFileRoute("/sitemap")({
  head: () => sitemapHead(),
  component: SitemapPage,
});
